define(function(require) {
	const tpl = require('./templates/t_itv_payment_summary.hbs');
	return Marionette.ItemView.extend({

		template: tpl,
		tagName:'li',
		className: 'selected-fee',
		events: {
			'click @ui.deleteFeeButton':'deleteFeeClicked'
		},
		modelEvents:{
			'change':'modelChanged'
		},
		ui: {
			'deleteFeeButton':'.delete-fee'
		},
		initialize: function(options) {
			this.config = options.config;
			this.id = options.model.id;
			this.$el.hide();//start hidden
		},
		onShow: function() {

		},
		modelChanged:function(model){
			if(model.get('payInPortal')){
				var prevCheck = this.model._previousAttributes.checked;
				var currentCheck = this.model.get('checked');
				if (prevCheck != currentCheck){//if checked has changed
					if(!model.get('parent')){
						if(model.get('checked')){
							this.triggerMethod('addFee',true);
							this.$el.show();
						} else {
							this.triggerMethod('addFee',false);
							this.$el.hide();
						}
					}
				}
			}
		},
		deleteFeeClicked:function(e){
			e.stopPropagation();
			e.preventDefault();
			this.model.set('checked',false);
		},
		templateHelpers: function() {
			var self = this;
			return {
				totalAmount:Handlebars.helpers['global:formatMoney'](self.model.get('totalUnpaidAmount')),
				deleteLabel: i18n.t('CIVICS.COMMON.DELETE') + ' ' + Handlebars.helpers['global:computedDescription'](self.model.get('portalDescription'), self.model.get('description'))+' ' +self.model.get('application').get('applicationNumber')
			}
		}
	});
});
